/**
 * External dependencies
 */

import React, { useState } from 'react';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import './styles.scss';
import FormLabel from 'components/forms/form-label';

const FormInputFloatingLabel = ({ label, FormInput, ...rest }) => {
    const [focused, setFocused] = useState(false);
    const classes = classNames('form-floating-label', {
        'form-floating-label--focused': focused,
        'form-floating-label--has-input': rest.value.length >= 1,
    });

    return (
        <div className={classes}>
            <FormInput autocomplete="off" {...rest} onBlur={() => setFocused(false)} onFocus={() => setFocused(true)} />
            <FormLabel className='form-floating-label__label'>{label}</FormLabel>
            <div className='form-floating__ripple' />
        </div>
    );
};


export default FormInputFloatingLabel;